import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./index";

interface HeaderState {
  showLogo: boolean;
  animateLogo: boolean;
  statusActive: boolean;
}

const initialState: HeaderState = {
  showLogo: true,
  animateLogo: false,
  statusActive: false,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setHeaderConfig: (state, action: PayloadAction<Partial<HeaderState>>) => {
      return { ...state, ...action.payload };
    },
    resetHeaderConfig: () => initialState,
  },
});

export const { setHeaderConfig, resetHeaderConfig } = headerSlice.actions;

export const selectHeaderConfig = (state: RootState) => state.header;

export default headerSlice.reducer;
